import { NewRechargeStep, NewRechargeStepStatus } from '../../types';
import { MAX_COMPLETABLE_STEP_ORDER, STEP_ORDER_MAP } from '../constants/stepOrder';
export const createStepStatusManager = (currentStep) => {
    const getStepStatus = (step) => {
        const currentStepOrder = STEP_ORDER_MAP[currentStep];
        const targetStepOrder = STEP_ORDER_MAP[step];
        if (targetStepOrder === currentStepOrder) {
            return NewRechargeStepStatus.ACTIVE;
        }
        if (currentStep === NewRechargeStep.SUMMARY) {
            if (targetStepOrder <= MAX_COMPLETABLE_STEP_ORDER) {
                return NewRechargeStepStatus.COMPLETED;
            }
            else {
                return NewRechargeStepStatus.INACTIVE;
            }
        }
        if (targetStepOrder < currentStepOrder) {
            return NewRechargeStepStatus.COMPLETED;
        }
        return NewRechargeStepStatus.INACTIVE;
    };
    const canNavigateToStep = (step) => {
        const stepStatus = getStepStatus(step);
        return stepStatus === NewRechargeStepStatus.COMPLETED || stepStatus === NewRechargeStepStatus.ACTIVE;
    };
    return {
        getStepStatus,
        canNavigateToStep,
    };
};
